import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";

const LOCALE_ROOT = "paywall_checkout.form.email_verification_states.otp_state";

interface ResendCodeSectionProps {
  isResending?: boolean;
  isSubmitting?: boolean;
  onResendClick: () => void;
}

export const ResendCodeSection = ({
  isSubmitting = false,
  isResending = false,
  onResendClick,
}: ResendCodeSectionProps) => (
  <div>
    {`${t([LOCALE_ROOT, "did_not_receive_code"])} `}
    <Link
      asButton
      variant="custom"
      typography="label-sm"
      hoverDecoration="underline"
      onClick={onResendClick}
      disabled={isSubmitting || isResending}
    >
      {isResending
        ? t([LOCALE_ROOT, "sending"])
        : t([LOCALE_ROOT, "resend_code"])}
    </Link>
  </div>
);
